import type { User } from "@supabase/supabase-js";

/**
 * Cached view of the signed-in user, kept in sync by AuthProvider.
 *
 * `supabase.auth.getUser()` performs a network round-trip and takes the auth
 * client's session lock. Dozens of components calling it concurrently on mount
 * serializes them and can hang the UI, so data-fetching code should use
 * `getCurrentUser()` instead.
 */
let cachedUser: User | null = null;

export const setCachedUser = (user: User | null) => {
  cachedUser = user;
};

export const getCurrentUser = async (): Promise<User | null> => {
  // AuthProvider restores the session before protected application routes are
  // mounted. Never call getSession() here: it takes the auth client's global
  // browser lock, so dozens of data loaders resuming together could all wait
  // forever behind a stalled token refresh.
  return cachedUser;
};
